
import { Alert } from '../../Models/Alert';


export const SHOW_ALERT = 'SHOW_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';


/************************  Begin Alert    ******************************/


// Show Alert
export interface ShowAlertAction {
  type: typeof SHOW_ALERT;
  payload: { notification: Alert };
}
export const showAlert = (notification: Alert): ShowAlertAction => {
  return {
    type: SHOW_ALERT,
    payload: {notification}
  };
}

// Remove Alert
export interface RemoveAlertAction {
  type: typeof REMOVE_ALERT;
  payload: { notificationId: string };
}
export const removeAlert = (notificationId: string): RemoveAlertAction => {
  return {
    type: REMOVE_ALERT,
    payload: { notificationId }
  };
}

/************************   End Alert    ******************************/

export type NotificationAction = 
  ShowAlertAction
  | RemoveAlertAction;
